<template>
  <div>
      <el-empty description="No Data" v-if="$store.getters.getInventoryMasterDataProps.log_list.length === 0">
            <el-button @click="$store.commit('addNewAssetServiceLogRow')" size="small">Add New Service Log</el-button>
        </el-empty>

        <el-table
            v-else
            :data="$store.getters.getInventoryMasterDataProps.log_list"
            style="width: 100%">
           <el-table-column
            label="Service Date">
            <template slot-scope="scope">
                <el-date-picker
                    size="small"
                    v-model="scope.row.service_date"
                    type="date"
                    style="width: 100%;"
                    value-format="yyyy-MM-dd"
                    format="MMM dd yyyy">
                </el-date-picker>
            </template>
            </el-table-column>
            
            <el-table-column 
            label="Service Type">
            <template slot-scope="scope">
                <el-select 
                    size="small"
                    v-model="scope.row.activity_type" 
                    filterable 
                    style="text-align: left;">
                    <el-option
                        label="Maintenance"
                        :value="0">
                        <span style="float: left" v-html="'Maintenance'"></span>
                    </el-option>
                    <el-option
                        label="Repair"
                        :value="1">
                        <span style="float: left" v-html="'Repair'"></span>
                    </el-option>
                </el-select> 
            </template>
            </el-table-column>
           
           <el-table-column 
            label="Supervised By">
            <template slot-scope="scope">
                <el-select 
                    :id="'staff_name'"
                    size="small"
                    v-model="scope.row.supervised_by_staff_id" 
                    filterable 
                    >
                    <el-option
                        v-for="(data, index) in $store.getters.getEmployeeMasterList.filter(t => t.active && t.staff_type === 0)"
                        :key="index"
                        :label="data.staff_name"
                        :value="data.id">
                        <span style="float: left" v-html="data.staff_name"></span>
                    </el-option>
                </el-select>
            </template>
            </el-table-column>

            <el-table-column 
            label="Service By">
            <template slot-scope="scope">
                <el-select 
                    :id="'staff_name'"
                    size="small"
                    v-model="scope.row.service_done_by_contact_id" 
                    filterable 
                    >
                    <el-option
                        v-for="(data, index) in $store.getters.getGenericContactList"
                        :key="index"
                        :label="data.full_name"
                        :value="data.id">
                        <span style="float: left" v-html="data.full_name"></span>
                    </el-option>
                </el-select>
            </template>
            </el-table-column>
           
            
            <el-table-column
                fixed="right"
                label="">
                <template slot-scope="scope">
                    <div style="text-align: right; display: flex; flex-direction: row; justify-content: flex-end; align-items: flex-end;">
                        
                        <el-tooltip class="item" effect="dark" content="Add">
                          <a @click="$store.commit('addNewAssetServiceLogRow')" style="cursor: pointer; font-size: 16px;">
                            <i class="el-icon-circle-plus"></i>
                          </a>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="Delete">
                          <el-popconfirm
                              @confirm="$store.commit('removeNewAssetServiceLogRow', scope.row.key)"
                              title="Are you sure to delete this?"
                              >
                                <a v-if="scope.row.id === 0" slot="reference" style="cursor: pointer; margin-left: 10px; color: red; font-size: 16px;">
                                  <i class="el-icon-delete"></i>
                                </a>
                              
                          </el-popconfirm>
                        </el-tooltip>
                        
                    </div>                                        
                </template>
            </el-table-column>
        </el-table>
  </div>
</template>

<script>
export default {
    
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/InventoryMaster/Form/ServiceLog.vue